import { useTranslation } from 'react-i18next';

export function RequiredFieldsLegend() {
  const { t } = useTranslation('audiences');

  return (
    <span className="text-xs text-muted-foreground">
      <span className="text-destructive">*</span>
      {t('audiences.requiredFieldsLegend.requiredFields')}
    </span>
  );
}
